import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/descRegistro/importer/descRegistroImporterActions';

export default importerReducers(actions);
